import { pxToRem } from './mixins'

const spaces = {
  xSmall: pxToRem(4),
  small: pxToRem(8),
  medium: pxToRem(12),
  large: pxToRem(16),
  xLarge: pxToRem(24),
  xxLarge: pxToRem(32),
}

export default spaces
